/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
import { ChangeDetectionStrategy, Component, inject, InjectionToken, Signal } from '@angular/core';
import { SiTranslatePipe } from '@siemens/element-translate-ng/translate';

import { SiFormError } from '../si-form-item/si-form-item.component';

export const SI_FORM_VALIDATION_TOOLTIP_DATA = new InjectionToken<Signal<SiFormError[]>>(
  'SiFormValidationTooltipData'
);

@Component({
  selector: 'si-form-validation-tooltip',
  imports: [SiTranslatePipe],
  template: `
    @for (error of errors(); track error.key) {
      <div>{{ error.message | translate: error.params }}</div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'class': 'd-flex flex-column gap-2 text-start'
  }
})
export class SiFormValidationTooltipComponent {
  protected errors = inject(SI_FORM_VALIDATION_TOOLTIP_DATA);
}
